import { Link, useParams } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { getArticlesByTopic } from '@/mocks/articles';
import { topics } from '@/mocks/site';
import useSeo from '@/hooks/useSeo';

const TopicDetail = () => {
  const { slug = '' } = useParams();
  const topic = topics.find((item) => item.slug === slug);
  const list = getArticlesByTopic(slug);

  useSeo({
    title: topic ? `${topic.name} - 独家爆料合集` : '主题分类 - 看瓜爆料',
    description: topic
      ? `${topic.desc} 看瓜爆料${topic.name}栏目持续更新独家一手内容，共收录 ${list.length} 篇深度爆料。`
      : '看瓜爆料主题分类页，汇集各方向的独家一手爆料内容。',
    keywords: `看瓜爆料,${topic ? topic.name : '主题分类'},独家爆料,娱乐圈内幕,一手私料`,
    path: `/topic/${slug}`,
    schema: [
      {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: topic ? `${topic.name} - 看瓜爆料` : '看瓜爆料主题分类',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
          { '@type': 'ListItem', position: 2, name: '爆料库', item: '/topics' },
          { '@type': 'ListItem', position: 3, name: topic ? topic.name : '主题分类' },
        ],
      },
    ],
  });

  if (!topic) {
    return (
      <SiteLayout>
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '爆料库', to: '/topics' }, { label: '分类不存在' }]} />
        <section className="mx-auto flex max-w-content flex-col items-center px-4 py-24 text-center md:px-6">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-3xl text-primary-600">
            <i className="ri-error-warning-line"></i>
          </span>
          <h1 className="mt-5 font-heading text-2xl font-bold text-foreground-950">没有找到这个分类</h1>
          <p className="mt-3 text-sm text-foreground-600">它可能已经调整或合并，去爆料库看看其他方向吧。</p>
          <Link
            to="/topics"
            className="mt-6 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            返回爆料库
          </Link>
        </section>
      </SiteLayout>
    );
  }

  return (
    <SiteLayout>
      <Breadcrumb
        items={[
          { label: '首页', to: '/' },
          { label: '爆料库', to: '/topics' },
          { label: topic.name },
        ]}
      />

      <section className="border-b border-background-200/70 bg-background-100/40">
        <div className="mx-auto flex max-w-content flex-col gap-6 px-4 py-10 md:flex-row md:items-center md:justify-between md:px-6 md:py-14">
          <div className="max-w-2xl">
            <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className={`${topic.icon} text-2xl`}></i>
            </span>
            <h1 className="mt-4 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              {topic.name}
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{topic.desc}</p>
          </div>
          <div className="shrink-0 rounded-lg border border-background-200/70 bg-background-50 px-6 py-5 text-center">
            <p className="font-heading text-3xl font-bold text-primary-600">{list.length}</p>
            <p className="mt-1 text-xs text-foreground-500">篇独家爆料</p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-content px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="mt-12 rounded-lg border border-background-200/70 bg-secondary-50 p-6 md:p-8">
          <h2 className="font-heading text-lg font-bold text-foreground-950">换个方向继续挖</h2>
          <p className="mt-2 text-sm text-foreground-600">其他栏目的独家爆料也在持续更新中。</p>
          <div className="mt-5 flex flex-wrap gap-2">
            {topics
              .filter((item) => item.slug !== topic.slug)
              .map((item) => (
                <Link
                  key={item.slug}
                  to={`/topic/${item.slug}`}
                  className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-full border border-background-200/70 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${item.icon} text-base text-accent-600`}></i>
                  {item.name}
                </Link>
              ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default TopicDetail;